export default "__VITE_ASSET__c1f6f6cc__"